import React, { useState } from "react";
import GenericCard from "@ui-components/Card/GenericCard";
import GenericTabs from "@ui-components/Tabs/GenericTabs";
import ProfileTab from "./ProfileTab";
import SecurityTab from "./SecurityTab";
import ActivityTab from "./ActivityTab";

const TABS = [
    { label: "Profile", value: "profile" },
    { label: "Security", value: "security" },
    { label: "Activity", value: "activity" },
];

const ProfilePage: React.FC = () => {
    const [activeTab, setActiveTab] = useState("profile");

    return (
        <div className="p-6 space-y-6">
            <GenericCard
                variant="primary"
                shadow="sm"
                hasBorder
                isCollapsible={false}
                headerContent={
                    <span className="text-sm text-semantic-text-secondary">
                        Manage your personal information, security settings, and activity.
                    </span>
                }
                bodyContent={
                    <div className="flex flex-col gap-6 mt-6 mb-6">
                        <GenericTabs
                            tabs={TABS}
                            activeTab={activeTab}
                            onTabChange={setActiveTab}
                            fullWidth={false}
                            size="sm"
                        />
                        <div>
                            {activeTab === "profile" && <ProfileTab />}
                            {activeTab === "security" && <SecurityTab />}
                            {activeTab === "activity" && <ActivityTab />}
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default ProfilePage;
